import Swiper, { Navigation, Lazy, Pagination, EffectFade } from "swiper";
import BranchesMap from "../modules/branches-map";
import ProductsSlider from "../modules/products-slider";
import Form from "../modules/form";

const Machinery = {
  init() {
    BranchesMap.init();
    ProductsSlider.init();
    $("form.cform").each(function () {
      new Form($(this)[0]);
    });
  },
};

export default Machinery;
